/* eslint-disable @typescript-eslint/naming-convention */
import { props, createAction } from '@ngrx/store';
import { CognitoUser } from '@aws-amplify/auth';
export const AuthActionType = {
  SetAuthenticated: '[Auth] Set Authenticated',
  SetUnauthenticated: '[Auth] Set Unauthenticated',
  DoFirstLogin: '[Auth] Do First Login',
  DoRefreshToken: '[Auth] Do Refresh Token',
};

export const SetAuthenticated = createAction(AuthActionType.SetAuthenticated);

export const SetUnauthenticated = createAction(AuthActionType.SetUnauthenticated);

export const DoFirstLogin = createAction(AuthActionType.DoFirstLogin);

export const DoRefreshToken = createAction(AuthActionType.DoRefreshToken);
